export default {
  createTitle: 'Новый ресторан',
  detailTitle: 'Ресторан',
  listTitle: 'Рестораны',
  homeLink: 'Добавить ресторан',
  empty: 'Рестораны не найдены',
  columns: {
    id: 'ID',
    title: 'Название',
    cuisineType: 'Кухня',
    tags: 'Метки',
    address: 'Адрес',
    deliveryTime: 'Доставка',
    hours: 'Часы работы',
    rating: 'Рейтинг',
    isActive: 'Акт.',
    status: 'Стc.',
    isOpen: 'Сейчас',
    sort: 'Сорт.',
    details: 'Подробно',
    ledgerId: 'Ledger ID',
    telegram: 'TG',
    menu: 'Меню',
    commission: 'Комиссия',
    userId: 'User ID',
    telegramChatId: 'TG ID',
  },
  values: {
    active: 'Да',
    inactive: 'Нет',
    statusActive: 'Активен',
    statusBlocked: 'Не активен',
    statusInactive: 'Не активен',
    open: 'Открыт',
    closed: 'Закрыт',
  },
  filters: {
    title: 'Фильтры',
    restaurantId: 'ID ресторана',
    restaurantIdPlaceholder: 'ID ресторана',
    restaurantTitle: 'Название',
    restaurantTitlePlaceholder: 'Название',
    cuisineType: 'Кухня',
    cuisineTypeAll: 'Все кухни',
    tags: 'Метки',
    tagsAll: 'Все метки',
    statusAll: 'Статус витрины',
    isActiveAll: 'Режим кухни',
    apply: 'Применить',
    reset: 'Сбросить',
  },
  fields: {
    ownerEmail: 'Email владельца',
    ownerPassword: 'Пароль владельца',
    ownerPasswordHint:
      'Если пользователя с таким email нет, пароль обязателен — будет создан новый аккаунт ресторана',
    title: 'Название',
    cuisineType: 'Тип кухни',
    cuisineTypeEmpty: 'Не указан',
    tags: 'Метки ресторана',
    tagsPlaceholder: 'Выберите метки',
    address: 'Адрес ресторана',
    addressPlaceholder: 'ул. X, 15, Нячанг',
    opensAt: 'Открывается (час, 0–24)',
    closesAt: 'Закрывается (час, 0–24)',
    deliveryTimeMin: 'Доставка от (мин)',
    deliveryTimeMax: 'Доставка до (мин)',
    rating: 'Рейтинг',
    reviewsCount: 'Количество отзывов',
    isActive: 'Ресторан активен (кухня)',
    status: 'Статус на витрине',
    statusBlocked: 'Заблокирован на витрине',
    statusHint: 'Blocked — скрыт из public; не путать с режимом кухни',
    sort: 'Сортировка на главной',
    sortHint: 'Меньше — выше в хвосте закрытых по часам; открытые на главной перемешиваются',
    commissionPercent: 'Комиссия, %',
    commissionPercentHint: 'Доля ресторана в процентах. 20% → 0.20 в API',
    telegramChatId: 'Telegram chat ID',
    telegramChatIdPlaceholder: '-1001234567890',
    telegramChatIdHint: 'ID чата ресторана (строка, можно с минусом)',
    supportTelegramUrl: 'Ссылка на чат поддержки',
    supportTelegramUrlPlaceholder: 'https://t.me/...',
    supportTelegramUrlHint: "Invite link или публичный {'@'}username чата поддержки → https://t.me/... (кнопка в ЛК ресторана)",
  },
  cuisineTypes: {
    russian: 'Русская',
    asian: 'Азиатская',
    frozen: 'Заморозка',
    grill: 'На мангале',
    dairy: 'Молочка',
    sushi: 'Суши и Роллы',
    fastfood: 'Фастфуд',
  },
  restaurantTags: {
    recommended: 'Рекомендуем',
    fast: 'Быстрая доставка',
    new: 'Новинка',
  },
  actions: {
    openDetails: 'Подробно',
    openDetailsNewWindow: 'Открыть подробнее в новом окне',
    openWalletNewWindow: 'Открыть кошелёк в новом окне',
    openUserNewWindow: 'Открыть пользователя в новом окне',
    openTelegram: 'Открыть Telegram',
    openMenu: 'Меню',
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
    submit: 'Сохранить ресторан',
    update: 'Сохранить изменения',
    submitting: 'Сохранение…',
  },
  success: 'Ресторан сохранён',
  updateSuccess: 'Ресторан обновлён',
  address: {
    searching: 'Ищем адрес…',
    coordinatesResolved: 'Координаты определены',
  },
  validation: {
    titleRequired: 'Введите название',
    ownerEmailRequired: 'Введите email владельца',
    deliveryRangeInvalid: '«До» не может быть меньше «от»',
    operatingHoursInvalid: 'Укажите час от 0 до 24',
    operatingHoursPairRequired: 'Заполните оба поля времени работы или оставьте оба пустыми',
    ratingRange: 'Рейтинг от 0 до 5',
    reviewsCountMin: 'Количество отзывов не может быть отрицательным',
    sortMin: 'Порядок не может быть отрицательным',
    commissionRange: 'Комиссия от 0 до 100%',
    locationRequired: 'Выберите адрес из подсказок, чтобы определить координаты',
    supportTelegramUrlInvalid: 'Укажите ссылку вида https://t.me/...',
  },
  errors: {
    loadList: 'Не удалось загрузить список ресторанов',
    loadDetail: 'Не удалось загрузить ресторан',
    notFound: 'Ресторан не найден',
    noSelection: 'Ресторан не выбран',
  },
  apiErrors: {
    generic: 'Не удалось сохранить ресторан. Попробуйте снова.',
    validation_error: 'Проверьте поля формы',
    resto_user_has_resto: 'У этого email уже есть ресторан',
    restaurant_owner_password_required: 'Для нового email укажите пароль владельца',
    unauthorized: 'Нужна авторизация',
    forbidden: 'Нет доступа',
  },
}
